import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { clientService } from '../services/clientService';
import { toast } from 'react-hot-toast';

export const useCreateClient = () => {
    const queryClient = useQueryClient();

    const [selectedStateId, setSelectedStateId] = useState('');
    const [selectedStateName, setSelectedStateName] = useState('');
    const [selectedCityId, setSelectedCityId] = useState('');
    const [selectedCityName, setSelectedCityName] = useState('');

    const { data: states = [], isLoading: loadingStates } = useQuery({
        queryKey: ['states'],
        queryFn: () => clientService.getStates().then(res => res.data.data),
    });

    const { data: cities = [], isLoading: loadingCities } = useQuery({
        queryKey: ['cities', selectedStateId],
        queryFn: () => clientService.getCitiesByState(selectedStateId).then(res => res.data.data),
        enabled: !!selectedStateId,
    });

    const createMutation = useMutation({
        mutationFn: (data) => clientService.createClient(data),
        onSuccess: () => {
            toast.success('Client created successfully!');
            queryClient.invalidateQueries(['companyClients']);
        },
        onError: (error) => {
            const msg = error.response?.data?.message || 'Failed to create client';
            toast.error(msg);
        },
    });

    return {
        states,
        cities,
        loadingStates,
        loadingCities,
        selectedStateId,
        setSelectedStateId,
        selectedStateName,
        setSelectedStateName,
        selectedCityId,
        setSelectedCityId,
        selectedCityName,
        setSelectedCityName,
        createClient: createMutation.mutate,
        isCreating: createMutation.isPending,
    };
};